const CURRENT_SESSION = "Spring 2022";

export default CURRENT_SESSION;
